import { useState, useCallback, useMemo } from 'react';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing contract search and filtering
 */
export function useContractSearch(contracts: ContractView[], showArchived: boolean) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredContracts = useMemo(() => {
    let result = contracts;

    // Filter by archive status (exclude Archived unless showArchived is true)
    result = result.filter((contract) => {
      if (showArchived) {
        return true; // Show all contracts
      }
      // Show contracts that don't have "Archived" status (null or "Active")
      return contract.status !== 'Archived';
    });

    // Filter by search term
    if (!searchTerm.trim()) {
      return result;
    }

    const searchLower = searchTerm.toLowerCase();
    return result.filter(
      (contract) =>
        contract.payer?.toLowerCase().includes(searchLower) ||
        contract.product?.toLowerCase().includes(searchLower) ||
        contract.financialClass?.toLowerCase().includes(searchLower) ||
        contract.facilityType?.toLowerCase().includes(searchLower) ||
        contract.calcType?.toLowerCase().includes(searchLower) ||
        contract.id?.toLowerCase().includes(searchLower)
    );
  }, [contracts, searchTerm, showArchived]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredContracts,
    handleSearchChange,
    handleClearSearch,
  };
}
